export const emailAddressPattern = /^[_a-zA-Z0-9-&!#\\$%´`\*\+/=\?\^']+(\.[_a-zA-Z0-9-&!#\$%´`\*\+/=\?\^']+)*(?!.*[@\-.]{2})@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z][a-zA-Z]+$/

export const patterns = {
  emailPattern: {
    pattern: emailAddressPattern,
    message: 'Dit is geen geldig e-mailadres',
  },
  websitePattern: {
    pattern:
      /^(http(s)?:\/\/)?(w{3}\.)?([-a-zA-Z0-9@:%._+~#=]{2,256})(\.[a-z]{2,}\b([-a-zA-Z0-9@:%_+.~#?&//=]*))+$/,
    message: 'Dit is geen geldige website',
  },
  insitutionNumberPattern: {
    pattern: /\d{6}/,
    message: 'een instellingsnummer bestaat uit 6 cijfers',
  },
  companyNumberPattern: {
    pattern: /[0-9]{4}\.[0-9]{3}\.[0-9]{3}/,
    message:
      'een Belgisch ondernemingsnummer bestaat uit 10 cijfers met een punt tussen de 3 groepen van cijfers',
  },
  vatNumberPattern: {
    pattern: /[A-Z]{2}[0-9]{7}[0-9A-Z]{0,5}/,
    message:
      'een Europees BTW-nummer bestaat uit een landcode gevolgd door een aansluitend blok van 7 cijfers gevolgd door 0 tot 5 alfanumerieke tekens (afhankelijk van het land)',
  },
};
